import { useMemo, useState } from 'react';

export default function OrderProductSuggestions({ catalog, search, onSearch, onSelect, loading, error, outlet, onReload }) {
  const [focused, setFocused] = useState(false);
  const matches = useMemo(() => {
    const terms = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
    return catalog.filter(item => {
      const text = [item.name, item.brand, item.product_code, item.quantity, item.units, item.mk_barcode, item.teluguname]
        .join(' ').toLowerCase();
      return terms.every(term => text.includes(term));
    }).slice(0, 20);
  }, [catalog, search]);
  return <div className="rounded-lg border border-gray-200" onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false);
  }}>
    <input aria-label="Search products to add item"
      value={search} onFocus={() => setFocused(true)} onChange={event => onSearch(event.target.value)}
      onKeyDown={event => { if (event.key === 'Escape') { setFocused(false); onSearch(''); } }}
      placeholder={`Search ${outlet || 'outlet'} products to add item`}
      className="m-2 h-9 w-[calc(100%-1rem)] rounded-lg border border-gray-300 px-3 text-sm outline-none focus:border-blue-500" />
    {(focused || search) && <div className="max-h-64 overflow-y-auto divide-y divide-gray-100" aria-label="Product suggestions">
      {loading ? <p role="status" className="p-3 text-sm">Loading products…</p> : <>
        {error && <p role="alert" className="p-3 text-sm text-red-700">{String(error)}</p>}
        {matches.map(item => <button type="button" key={item.key} onClick={() => { onSelect(item); setFocused(false); }}
          className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left hover:bg-blue-50">
          <span className="min-w-0"><span className="block text-sm font-semibold">{item.name}</span>
            <span className="block text-xs text-gray-500">{item.brand} | {item.quantity} {item.units} | Stock {item.stock}</span></span>
          <span className="text-sm font-bold">Rs. {Number(item.price || 0).toFixed(2)}</span>
        </button>)}
        {!matches.length && <p role="status" className="p-3 text-sm text-gray-600">{catalog.length
          ? 'No matching products. Try the product name, brand, barcode or pack size.'
          : `No products loaded for ${outlet || 'this outlet'}. Reload products to try again.`}</p>}
        <button type="button" onClick={onReload} className="p-3 text-sm font-semibold text-blue-700">Reload products</button>
      </>}
    </div>}
  </div>;
}
